<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <b-modal :id="modalId" title="Nạp USDT" ok-title="Xác nhận" cancel-title="Đóng" size="md">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100">
          <h4>Nạp USDT</h4>
        </div>
      </template>
      <template #default>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <b class="text-primary">Hướng dẫn</b>
              <p class="mb-2">
                Để nạp tiền vào hệ thống, quý khách vui lòng chuyển <span class="text-green">USDT</span> vào địa chỉ bên dưới bằng cách copy
              </p>
              <div class="input-group mb-2">
                <input v-model="getMe.user.usdt_wallet_address" type="text" class="form-control" style="color: #000000">
                <div class="input-group-append" @click="copyToClipBoard()">
                  <span class="input-group-text btn-copy" ref="button-copy" style="font-size: 14px;">
                    <i class="las la-copy"></i>
                    Copy
                  </span>
                </div>
              </div>
              <p class="mb-2 text-center">Hoặc <b>scan</b> mã QR dưới đây</p>
              <p class="mb-2 text-center">
                <img :src="`https://chart.apis.google.com/chart?cht=qr&amp;chs=300x300&amp;chl=${getMe.user.usdt_wallet_address}&amp;chld=H|0`" alt="qr" class="img-thumbnail">
              </p>
              <b class="text-red">Ghi chú</b>
              <ol style="list-style-type: circle">
                <li>
                  Chỉ chấp nhận <span class="text-green">USDT</span> từ mạng lưới <span class="text-red">TRC20</span>. Tất cả giao dịch từ hệ thống khác sẽ không được xác nhận và
                  hoàn trả.
                </li>
                <li>
                  Số tiền nạp vào sẽ tự động cộng vào tài khoản của bạn ngay khi chúng tôi nhận được và hoàn thành việc xác
                  thực.
                </li>
              </ol>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-12">
              <p>Các trang web <b class="text-yellow">mua bán USDT uy tín</b>, quý khách có thể xem qua:</p>
              <ul style="list-style-type: decimal">
                <li><a target="_blank" href="https://p2p.binance.com/en?fiat=VND&payment=ALL">Binance P2P ⭐⭐⭐⭐</a></li>
                <li><a target="_blank" href="https://remitano.com/btc/sg">Remitano ⭐⭐⭐⭐</a></li>
                <li><a target="_blank" href="https://www.fiahub.com/">Fiahub ⭐⭐⭐⭐</a></li>
                <li><a target="_blank" href="https://chimcugay.com/">Chimcugay ⭐⭐⭐⭐</a></li>
              </ul>
              <p class="text-yellow">📞 Liên hệ bộ phận kỹ thuật nếu có trở ngại.</p>
              <p class="text-yellow">💖 Chân thành cảm ơn !!! 💖</p>
            </div>
          </div>
        </div>
      </template>
      <template #modal-footer>
        <contact-button/>
        <b-button variant="secondary" @click="$bvModal.hide(modalId)">Đóng</b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<script>
import { mapGetters } from 'vuex'
import { copyTextToClipboard } from '@/utils'
import ContactButton from '@/components/application/misc/ContactButton'

export default {
  name: 'DepositModal',
  components: { ContactButton },
  data () {
    return {
      'usdt_address': ''
    }
  },
  props: {
    modalId: {
      type: String,
      default: 'deposit-usdt-modal'
    },
    inputStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          display: 'block'
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      'getMe': 'Auth/authUserState',
      'serverError': 'Setting/serverErrorsState',
      'serverRequesting': 'Setting/serverRequestingState'
    })
  },
  methods: {
    copyToClipBoard () {
      copyTextToClipboard(this.getMe.user.usdt_wallet_address)
      this.$refs['button-copy'].innerHTML = '<i class="las la-check"></i> Copied'
    }
  }
}
</script>
